import QRCode from 'qrcode';

export const qrCodeService = {
  
  generateQRCode: async (tableName, id) => {
    try {
      const qrData = `${tableName}/${id}`;
      const qrCode = await QRCode.toDataURL(qrData);
      return qrCode;
    } catch (error) {
      console.error("Error generating QR code:", error);
      throw error;
    }
  },

  generateCustomQRCode: async (data, options = {}) => {
    try {
      const defaultOptions = {
        width: 400,
        margin: 2,
        ...options
      };
      const qrCode = await QRCode.toDataURL(data, defaultOptions);
      return qrCode;
    } catch (error) {
      console.error("Error generating custom QR code:", error);
      throw error;
    }
  },

  
  generateProductQRCode: async (productId, productName) => {
    try {
      const qrData = JSON.stringify({
        productId,
        productName,
        type: 'product',
        timestamp: Date.now()
      });
      return await qrCodeService.generateCustomQRCode(qrData);
    } catch (error) {
      console.error("Error generating product QR code:", error);
      throw error;
    }
  }
};